import React from 'react';

import BaseLandingPage from 'components/landing/BaseLandingPage';

const BuyerLandingPage: React.FC = () => {
  return (
    <BaseLandingPage
      headerText="Save time and money"
      subHeaderText="Buy construction supplies with the best prices in minutes"
      callToActionText="Sign up"
      callToActionLink="https://sansantech.vercel.app/sign-up"
    />
  );
};

export default BuyerLandingPage;
